import navbar from './navbar'
import footer from './footer'
import home from './home/index'
import weAreSis from './weAreSis/index'
import solutions from './solutions'
import innovation from './innovation'
import career from './career'
import blog from './blog'
import contact from './contact'
import beSis from './beSis'
import lgpd from './lgpd'
import pageNotFound from './pageNotFound'
import products from './products'
import transformation from './transformation'
import shared from './shared'
import clientsAndPartners from './clientsAndPartners'
import servicesProducts from './servicesProducts'
import whatWeDo from './whatWeDo'

export default {
  ...servicesProducts,
  ...navbar,
  ...footer,
  ...home,
  ...weAreSis,
  ...solutions,
  ...innovation,
  ...career,
  ...blog,
  ...contact,
  ...beSis,
  ...lgpd,
  ...pageNotFound,
  ...products,
  ...transformation,
  ...shared,
  ...clientsAndPartners,
  ...whatWeDo,
  codeEthics: {
    metatag: {
      title: 'Código de ética y conducta - SIS Innov & Tech',
      description:
        'En nuestro Código de Ética & Conducta, le explicamos cómo llevamos a cabo todas las actividades, internas y externas, en base a esta guía.',
    },
  },
  cookies: {
    metatag: {
      title: 'Cookie policy - SIS Innov & Tech',
      description:
        'En nuestra Política de Cookies, explicamos qué son las cookies, cómo y por qué utilizamos la información capturada por ellas.',
    },
  },
  privacyPolicy: {
    metatag: {
      title: 'Política de privacidad - SIS Innov & Tech',
      description:
        'Nuestra Política de Privacidad se aplica a toda la información recopilada en nuestro sitio web. Proporcionamos información sobre cómo recopilamos, utilizamos y tratamos sus datos personales',
    },
  },
}
